/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsCostCalculatorAuthenticated204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsCostCalculatorAuthenticated505Schema = z.any();

export const optionsCostCalculatorAuthenticatedMutationResponseSchema = z.lazy(
  () => optionsCostCalculatorAuthenticated204Schema
);
